export const EVENT_LOGS = 'eventLogs';

export const EVENT_LOGS_ACTIONS_NAME = {
  getEventLogs: `${EVENT_LOGS}/getEventLogs`,
  getSeverities: `${EVENT_LOGS}/getSeverities`,
  getModules: `${EVENT_LOGS}/getModules`,
  getEntityTypes: `${EVENT_LOGS}/getEntityTypes`,
};

export const EVENT_LOGS_MUTATIONS_NAME = {
  setEventLogs: `${EVENT_LOGS}/setEventLogs`,
  setSeverities: `${EVENT_LOGS}/setSeverities`,
  setModules: `${EVENT_LOGS}/setModules`,
  setEntityTypes: `${EVENT_LOGS}/setEntityTypes`,
};

export const EVENT_LOGS_GETTERS_NAME = {
  getEventLogs: `${EVENT_LOGS}/getEventLogs`,
  getSeverities: `${EVENT_LOGS}/getSeverities`,
  getModules: `${EVENT_LOGS}/getModules`,
  getEntityTypes: `${EVENT_LOGS}/getEntityTypes`,
};
